<template>
    <div>
        <home-header :title="i18n('Administration')"></home-header>

        <home-grid users settings reports logs></home-grid>

    </div>
</template>

<script>
    import HomeGrid from "../main/HomeGrid";
    import HomeHeader from "../main/HomeHeader";

    export default {
        components: {HomeHeader, HomeGrid}
    }
</script>

<style></style>
